var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-tags-view',{attrs:{"save-button-text":_vm.$t('Show'),"loading":_vm.loading,"tags":_vm.tags,"minimum-selection":0,"pre-selected-tags":_vm.selectedTags},on:{"save":_vm.onSave,"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }